import styled from 'styled-components';

const NotFoundPageHolder = styled.div`
.row {
    clear: both;
    display: flex;
    justify-content: space-around;
    flex-flow: row;
    align-items: stretch;
}
a {
    color: #7a7652;
    text-decoration: none;
    touch-action: manipulation;
}

.article-bg {
    max-width: 80%;
    margin: 80px auto;
    background-color: rgba(255, 255, 255, 0.2);
    padding: 20px;
    border-radius: 20px;
    @media (max-width: 540px) {
        max-width: 100%;
        padding: 10px;
    }

    .container {
        
        margin: 20px auto 40px;
        .entry-content {
            hr {
                margin: 1rem 0;
                border: 0;
                border-top: 1px solid rgba(0, 0, 0, 0.1);
                height:0;
                overflow: visible;
                box-sizing: content-box;
            }	
            @media (min-width: 48em) {
                padding-left: 1.5rem;
                padding-right: 1.5rem;
            }
            @media (max-width: 767px) {
                padding-left: .8rem;
                padding-right: .8rem;
            }
            
            .article_content {
                padding-top: 1.rem;
            }
            span {
                &.content-title {
                    color: #383838;
                    font-size: 25px;
                    font-size: 2.5rem;
                    margin-top: 0;
                    margin-bottom: 1rem;
                    font-weight: 500;
                    line-height: 1.2;
                }
            }
        }	
    }
    .search-not-found {
		margin-top:1rem;
	}
    .search-container {
		position: relative;
		max-width: 576px;
		margin: 1.5rem auto;
			input {
			    font-size: 16px;
			    font-weight: 700;
			    width: 100%;
			    padding: 12px;
			    color: #606060;
			    border: 1px solid #d1cdc1;
			    border-radius: 5px;
			    outline: 0;
			    background-color: #fff;
			    border-radius: 2em;
			    text-align: left;
				@media only screen and (max-width: 920px) {
					text-align: left;
				}
				&:focus {
					text-align: left;
				}
			}
			button {
				position: absolute;
				right: 4px;
				top: 3px;
				border: solid 5px #d1cdc1;
				transition: all 0.3s ease-out;
				font-family: NexaX, Helvetica, Arial, sans-serif;
				font-size: 14px;
				line-height: 0.6;
				font-weight: bold;
				display: inline-block;
				height: auto;
				cursor: pointer;
				text-align: center;
				text-decoration: none;
				letter-spacing: 0.025em;
				border-radius: 4px;
				color: white;
				width: auto;
				min-width: 0;
				padding: 10px;
				background: #7a7652;
				max-height: 50px;
				margin: 15;
				border-radius: 2em;

				&:hover {
					background-color: #a69e87;
					border: solid 5px #a69e87;
				}
			}
		}
	}
    
}

`;

export default NotFoundPageHolder;